import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@kuroo/ui/tokens.css";
import "@kuroo/ui/ui.css";
import { applyThemePreference } from "@kuroo/ui";
import { BackofficeApp } from "./App";
// The provider workspace intentionally reuses the operational surface from
// the former portal. Keep its component-specific layout rules in the bundle
// while the Backoffice stylesheet remains the owner of shell/admin styles.
import "../../portal/src/styles.css";
import "./styles.css";

applyThemePreference();

createRoot(document.getElementById("root")!).render(<StrictMode><BackofficeApp /></StrictMode>);
